"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IbanInput = void 0;

var react_1 = __importDefault(require("react"));

var IbanInput_1 = __importDefault(require("../../models/IbanInput"));

var Input_1 = __importDefault(require("../Form/Input"));

var clsx_1 = __importDefault(require("clsx"));

require("./Iban.scss");

exports.IbanInput = function () {
  var e_1, _a;

  var iban_props = IbanInput_1.default;
  var refsInput = {};

  try {
    for (var _b = __values(Object.keys(iban_props)), _c = _b.next(); !_c.done; _c = _b.next()) {
      var name_1 = _c.value;
      refsInput[name_1] = react_1.default.useRef(null);
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  var onchangeIbanInput = function onchangeIbanInput(e) {
    var _a = e.target,
        value = _a.value,
        name = _a.name;
    var reg = /^.{4}$/;
    var nextIndex = Object.keys(iban_props).indexOf(name) + 2;
    var inputLength = Object.keys(iban_props).length;
    var nextRefIndex = "iban_field_" + nextIndex;

    if (reg.test(value)) {
      var nextValue = refsInput[nextRefIndex].current.value;

      if (nextIndex < inputLength + 1 && value.length > 0 && !nextValue) {
        refsInput[nextRefIndex].current.focus();
      }
    }
  };

  var displayIbanInput = Object.keys(iban_props).map(function (name, i) {
    return react_1.default.createElement(Input_1.default, __assign({
      key: name,
      showSpecificError: false,
      changeCase: "upperCase",
      ref: refsInput[name],
      valid: false,
      name: name,
      onChange: onchangeIbanInput
    }, iban_props[name], {
      className: clsx_1.default("cy-input-" + (i + 1) + "-iban", 'col-3 col-md-1 px-1 mx-0 mx-md-2 iban-input')
    }));
  });
  return react_1.default.createElement(react_1.default.Fragment, null, displayIbanInput);
};